module.exports={
	"Form": "TestSpecificationViewManifest",
	"Scope": "TestSpecification-View",
	"Descriptors":
	{
		"TestSpecificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecification-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecification-View-Identity",
				"Group": "TestSpecification-View-Identity"
			}
		},
		"TestSpecificationDetails.IDTestSpecificationSet":
		{
			"Name": "Test Specification Set",
			"Hash": "TestSpecification-View-IDTestSpecificationSet",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecification-View-Details",
				"Group": "TestSpecification-View-Details",
				"Entity": "TestSpecificationSet",
				"SearchFields":
				[
					"Name"
				],
				"ReadOnly": true
			}
		},
		"TestSpecificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "TestSpecification-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "TestSpecification-View-Details",
				"Group": "TestSpecification-View-Details"
			}
		},
		"TestSpecificationDetails.IDTestSpecification":
		{
			"Name": "IDTest Specification",
			"Hash": "TestSpecification-View-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.GUIDTestSpecification":
		{
			"Name": "GUIDTest Specification",
			"Hash": "TestSpecification-View-GUIDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecification-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecification-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecification-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		},
		"TestSpecificationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecification-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecification-View-DataAudit",
				"Group": "TestSpecification-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecification-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecification-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecification-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecification-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecification-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecification-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
